import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@core/services/api/apiRequest";
import type { FeaturedOrganization } from "../organization.types";

/**
 * Which organizations a public page names: the ones staff marked as featured,
 * every one staff listed themselves, or every approved one.
 */
export type OrganizationScope = "featured" | "staff" | "all";

/**
 * Fetch the organizations in the network, for the marketing site's full list.
 *
 * Returns each organization in the scope with name and location only, by name.
 * Results are cached for 5 minutes since the list doesn't change often.
 */
export function useFetchPublicOrganizations(scope: OrganizationScope = "featured") {
  return useQuery<FeaturedOrganization[]>({
    queryKey: ["organizations", "public", scope],
    queryFn: async () => {
      return apiRequest(
        `/organizations/public/?scope=${scope}`,
        "GET",
        null,
        false
      ) as Promise<FeaturedOrganization[]>;
    },
    staleTime: 5 * 60 * 1000,
  });
}
